import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, CrossIcon, FlexRow, MyEmailIcon, SmallText } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { dealTokens, SystemIconButton } from 'components/shared';

const EmailNotVerified = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <FlexRow
      margin={0}
      marginTop={1}
      minHeight={50}
      alignItems="center"
      backgroundColor={dealTokens.color.noteSoft}
      xs={12}
      border={borderDefinition(dealTokens.color.note, '2px')}
      borderRadius={smallBorderRadius}
    >
      <FlexRow alignItems="center" justifyContent="space-between" paddingLeft={2} margin={0}>
        <FlexRow xs={12} alignItems="center" margin={0}>
          <Block xs={1.2} margin={0} display="flex" alignItems="center">
            <MyEmailIcon htmlColor={dealTokens.color.note} />
          </Block>
          <SmallText xs={9.4} fontSize="0.9rem" fontWeight="800" color={dealTokens.color.text} textAlign="center">
            {t('ONBOARD.verifyMessage')}
          </SmallText>
          <Block xs={1.4} margin={0} display="flex" alignItems="center" justifyContent="end" paddingRight={2}>
            <SystemIconButton icon={<CrossIcon />} label={t('GENERAL.close')} onClick={() => onClose()} />
          </Block>
        </FlexRow>
      </FlexRow>
    </FlexRow>
  );
};

export default EmailNotVerified;
